import { computed } from 'vue-demi';
import { useCurrentAccount, useCurrentUser } from '@teamwork/use';
import moment from 'moment';
import useRouter from '@/platform/composables/useRouter';

export default function usePubbleMetadata() {
  const user = useCurrentUser();
  const account = useCurrentAccount();
  const router = useRouter();

  function commonPendoFields() {
    const userRole = computed(() => {
      if (user.value.siteOwner) {
        return 'Site Owner';
      }
      if (user.value.administrator) {
        return 'Administrator';
      }
      if (user.value.isClientUser) {
        return 'Client User';
      }
      if (user.value.isCollaborator) {
        return 'Collaborator';
      }
      return undefined;
    });

    const planName = account.value.pricePlanData.name;

    const page = router.currentRoute.path;

    const firstPaymentDate = account.value.installationDateFirstPayment;

    let daysSincePurchase;
    if (firstPaymentDate) {
      const firstPaymentMoment = moment(firstPaymentDate);
      if (moment.isMoment(firstPaymentMoment)) {
        const currentDate = moment().startOf('day');
        daysSincePurchase = currentDate.diff(firstPaymentDate, 'days');
      }
    }

    return {
      plan_name: planName,
      user_role: userRole.value,
      page,
      days_since_purchase: daysSincePurchase,
    };
  }

  return {
    commonPendoFields,
  };
}
